import React from "react";
import "./social-media-share.m.css";
import get from "lodash/get";
import Whatsapp from "../../atoms/social-media-icons/Whatsapp";
import Facebook from "../../atoms/social-media-icons/Facebook";
import Twitter from "../../atoms/social-media-icons/Twitter";
import Telegram from "../../atoms/social-media-icons/Telegram";
import LinkedIn from "../../atoms/social-media-icons/LinkedIn";
import Mail from "../../atoms/social-media-icons/Mail";

const SOCIAL_MEDIA_SHARE = [
  {
    name: "whatsapp",
    type: "whatsapp_round",
    bgColor: "##FFFFFF",
    icon: <Whatsapp width="19" height="19" color="#25D366" />
  },
  {
    name: "facebook",
    type: "facebook_round",
    bgColor: "#FFFFFF",
    icon: <Facebook width="19" height="19" color="#0866FF" />
  },
  {
    name: "twitter",
    type: "twitter_round",
    bgColor: "#FFFFFF",
    icon: <Twitter width="19" height="19" color="black" />
  },
  {
    name: "telegram",
    type: "telegram_round",
    bgColor: "#FFFFFF",
    icon: <Telegram width="19" height="19" color="#2396D0" />
  },
  {
    name: "linkedin",
    type: "linkedin_round",
    bgColor: "#FFFFFF",
    icon: <LinkedIn width="19" height="19" color="#2867B2" />
  },
  {
    name: "mail",
    type: "mail_round",
    bgColor: "#FFFFFF",
    icon: <Mail width="19" height="19" color="#1C1B1F" />
  }
];

const socialMediaUrl = (type, headline, publishedURL) => {
  const encodedHeadline = encodeURIComponent(headline);
  let url;

  switch (type) {
    case "facebook":
      url = `http://en-gb.facebook.com/sharer/sharer.php?utm_source=prajavani&utm_medium=facebook&u=${encodeURIComponent(
        publishedURL + "?utm_source=facebook&utm_medium=referral&utm_campaign=socialshare"
      )}&t=${encodedHeadline}`;
      break;
    case "twitter":
      url = `https://twitter.com/intent/tweet?utm_source=prajavani&utm_medium=twitter&url=${encodeURIComponent(
        publishedURL + "?utm_source=twitter&utm_medium=referral&utm_campaign=socialshare"
      )}&text=${encodedHeadline}&via=prajavani`;
      break;
    case "whatsapp":
      url = `https://api.whatsapp.com/send?utm_source=prajavani&utm_medium=whatsapp&text=${encodedHeadline} ${encodeURIComponent(
        publishedURL + "?utm_source=whatsapp&utm_medium=referral&utm_campaign=socialshare"
      )}`;
      break;
    case "linkedin":
      url = `http://www.linkedin.com/shareArticle?utm_source=prajavani&utm_medium=linkedin&mini=true&title=${encodedHeadline}
      &url=${encodeURIComponent(publishedURL + "?utm_source=linkedin&utm_medium=referral&utm_campaign=socialshare")}`;
      break;
    case "telegram":
      url = `https://t.me/share/url?utm_source=prajavani&utm_medium=telegram&url=${encodeURIComponent(
        publishedURL + "?utm_source=telegram&utm_medium=referral&utm_campaign=socialshare"
      )}`;
      break;
    case "mail":
      url = `mailto:?subject=${encodedHeadline}&body=${encodedHeadline}:%20${encodeURIComponent(
        publishedURL + "?utm_source=mail&utm_medium=referral&utm_campaign=socialshare"
      )}`;
      break;

    default:
      url = "";
      break;
  }
  return url;
};

const SocialMediaShare = ({ story, isAmpStory = false }) => {
  const { headline, url } = story;
  const altSocialHeadline = get(story, ["alternative", "social", "default", "headline"], headline);

  return (
    <div className="social-wrapper" styleName="social-wrapper">
      {SOCIAL_MEDIA_SHARE.map((share, index) => (
        <a
          key={index}
          // style={{ backgroundColor: `${share.bgColor}` }}
          target="_blank"
          rel="nofollow noreferrer"
          href={socialMediaUrl(share.name, altSocialHeadline, url)}
        >
          {share.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialMediaShare;
